



































import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class DriversLicense extends Vue {
  @Prop()
  front!: string;
  @Prop()
  back!: string;

  isFrontSelected = true;
  toggleFrontLicense() {
    this.isFrontSelected = true;
  }
  toggleBackLicense() {
    this.isFrontSelected = false;
  }
}
